import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PlanService } from 'app/services/plan/plan.service';

@Component({
  selector: 'app-liste-plans',
  templateUrl: './liste-plans.component.html',
  styleUrls: ['./liste-plans.component.scss']
})
export class ListePlansComponent implements OnInit {

  dataSource = new MatTableDataSource();
  Plans:any
  constructor(private plansService:PlanService) { }

  getData() {
    this.plansService.getListPlan().subscribe((data) => {
      this.Plans = data;
    });
  }
  ngOnInit() {
    this.plansService.refreshNedeed.subscribe(() => this.getData());
    this.getData()
  }
  deletePlan(pieceProduit: any) {
    this.plansService.deletePlan(pieceProduit.id).subscribe((response: any) => {


      console.log(this.dataSource.data);


    });
    setTimeout(() => {
      this.getData()
    }, 500)

  }

}
